export const FETCH_BETGAMES_TOKEN = 'FETCH_BETGAMES_TOKEN';
export const SUCCESS_FETCH_BETGAMES_TOKEN = 'SUCCESS_FETCH_BETGAMES_TOKEN';
export const FAILURE_FETCH_BETGAMES_TOKEN = 'FAILURE_FETCH_BETGAMES_TOKEN';


// WEBPACK FOOTER //
// ./js/actions/betGames/index.js